import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ErrorService } from 'src/app/shared/services/error.service';
import { RssService } from 'src/app/shared/services/rss.service';
import { UserPreferenceService } from 'src/app/shared/services/userpreferences.service';
import {RssFeedEntry} from '../../../shared/model/rssFeedEntry';

@Component({
  selector: 'app-blogs',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})

export class BlogComponent implements OnInit {
  loading: boolean;
  feedData: RssFeedEntry[];
  postType = 'orange_blog';

  constructor(
    private route: ActivatedRoute,
    private userprefService: UserPreferenceService,
    private rssService: RssService,
    private errorService: ErrorService) { }

  ngOnInit(): void {
    this.loading = true;
    this.userprefService.getUserPreferences()
      .then(res => {
        let region = 'global';
        if (res.region) {
          region = res.region;
        }
        this.rssService.rss(region, this.postType)
          .then(res2 => {
            this.feedData = res2 as RssFeedEntry[];
            this.loading = false;
          });
      })
      .catch(err => {
        this.errorService.handlerError(err);
        this.loading = false;
      });
  }
}
